import BaseEndpoint from '@/api/endpoints/base-endpoint'

export default class ContentEndpoint extends BaseEndpoint {}
